export interface NavLink {
  to: string
  label: string
}

export const serviceLinks: NavLink[] = [
  { to: '/services/web-development', label: 'Web Development' },
  { to: '/services/frontend-development', label: 'Frontend Development' },
  { to: '/services/backend-development', label: 'Backend Development' },
  { to: '/services/api-development', label: 'API Development' },
  { to: '/services/mobile-app-development', label: 'Mobile App Development' },
  { to: '/services/devops-deployment', label: 'DevOps & Deployment' },
]

export const mainLinks: NavLink[] = [
  { to: '/projects', label: 'Projects' },
  { to: '/services', label: 'Services' },
  { to: '/about', label: 'About Us' },
  { to: '/contact', label: 'Contact' },
]
